// adding ignore list for now. need to take these components and pass the state from here (Home  and dept).
function ignoreList(componentName) {
    const listIgnore = ['header', 'footer'];
    return listIgnore.indexOf(componentName);
}

export default (oneComponent, index, irisCompleteComponentList) => {
    let mappedComponent = null;
    const { componentType } = oneComponent;
    /* istanbul ignore else */
    if (oneComponent.componentType && ignoreList(oneComponent.componentType) < 0) {
        const CustomComponent = irisCompleteComponentList[oneComponent.componentType];
        mappedComponent = {
            componentType,
            component: CustomComponent,
            props: oneComponent,
            index,
        };
    }
    if (!mappedComponent) {
        console.warn('IRIS: component name missmatch, check Iris Response');
    }
    return mappedComponent;
};
